function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import productPricingConfig from "segments/desktop/pricing/product-pricing-config";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import PricesAndFeaturesCardsPricing from "../prices-and-features-cards-pricing/index.js";
import FeatureTablePricing from "../features-table-pricing/index.js";
import { StyledMultiProductsPricingComponent } from "./multi-products-pricing-component.scss";
import { shouldSeeNewPricing } from "services/pricing-service";
import { UNIT_OF_MEASURE } from "segments/desktop/pricing/constants";
const MultiProductsPricingComponent = (props)=>{
    const { pricesAndFeaturesCardsPricing, translate } = props;
    const { isHomepagePricing = false, isApplyMaxDiffFeatures = false, defaultSeatsIndex = 0, unitOfMeasure = UNIT_OF_MEASURE.SEATS } = pricesAndFeaturesCardsPricing;
    const selectedProductName = "core";
    const selectedProductColors = {
        primaryColor: productPricingConfig.core.primaryColor,
        secondaryColor: productPricingConfig.core.secondaryColor
    };
    return /*#__PURE__*/ _jsxs(StyledMultiProductsPricingComponent, {
        className: "multi-products-pricing-component",
        style: {
            "--primary-color": selectedProductColors.primaryColor,
            "--secondary-color": selectedProductColors.secondaryColor
        },
        children: [
            /*#__PURE__*/ _jsx(SignupFormComponent, {
                className: "signup-form",
                ctaText: translate("signup.cta"),
                buttonColor: selectedProductColors.primaryColor,
                buttonSize: "xs",
                useCtaText: true,
                withButtonArrow: true,
                signupProductId: productPricingConfig.core.productId,
                extraData: {
                    productKind: selectedProductName,
                    cta_name: "main_cta"
                }
            }),
            /*#__PURE__*/ _jsx(PricesAndFeaturesCardsPricing.PricesAndFeaturesCardsPricingComponent, _object_spread_props(_object_spread({}, props), {
                productName: selectedProductName,
                isHomepagePricing: isHomepagePricing,
                defaultSeatsIndex: defaultSeatsIndex,
                unitOfMeasure: unitOfMeasure,
                isApplyMaxDiffFeatures: isApplyMaxDiffFeatures,
                isNewPricing: shouldSeeNewPricing(selectedProductName),
                crossedPricingUI: false
            })),
            /*#__PURE__*/ _jsx(FeatureTablePricing.FeaturesTablePricingComponent, _object_spread_props(_object_spread({}, props), {
                productName: selectedProductName,
                isHomepagePricing: isHomepagePricing,
                defaultSeatsIndex: defaultSeatsIndex,
                unitOfMeasure: unitOfMeasure,
                isApplyMaxDiffFeatures: isApplyMaxDiffFeatures,
                isNewPricing: shouldSeeNewPricing(selectedProductName)
            }))
        ]
    });
};
export default MultiProductsPricingComponent;
